import { SVGProps } from 'react';

const SharedListingArrow = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="18" width="18" fill="none" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="9" cy="9" r="8.5" stroke="white" />
      <path
        d="M8.54379 7.12428C6.14368 7.39516 4.32938 9.42467 4.32812 11.84C4.32812 11.9416 4.45727 11.9892 4.52626 11.9146C5.56109 10.7958 7.0114 10.1438 8.54379 10.1183V11.7035C8.54385 11.9335 8.67532 12.1432 8.8823 12.2435C9.08928 12.3438 9.33537 12.317 9.51592 12.1745L13.4408 9.07542C13.5801 8.9656 13.6615 8.79797 13.6615 8.62055C13.6615 8.44313 13.5801 8.27549 13.4408 8.16568L9.51592 5.06655C9.33537 4.92407 9.08928 4.89729 8.8823 4.99759C8.67532 5.09789 8.54385 5.30764 8.54379 5.53764V7.12428Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default SharedListingArrow;
